import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useBlogAuth } from '../auth/blog-auth-context';
import type { BlogApiClient } from './client';
import { createBlogApiClient } from './index';

const BlogApiContext = createContext<BlogApiClient | null>(null);

/**
 * Provê o {@link BlogApiClient} ativo, ligado à sessão do portal para o client
 * real receber um token fresco por requisição. Fica DENTRO do BlogAuthProvider.
 */
export function BlogApiProvider({ children }: { children: ReactNode }): JSX.Element {
  const { getAccessToken } = useBlogAuth();
  const client = useMemo(() => createBlogApiClient(getAccessToken), [getAccessToken]);
  return <BlogApiContext.Provider value={client}>{children}</BlogApiContext.Provider>;
}

/** Acessa o client ativo da Members API. Lança fora do {@link BlogApiProvider}. */
export function useBlogApi(): BlogApiClient {
  const client = useContext(BlogApiContext);
  if (!client) {
    throw new Error('useBlogApi must be used within a BlogApiProvider.');
  }
  return client;
}
